import {
  useCompositeStoreOptions,
  useCompositeStoreProps
} from "../__chunks/7KULBIZY.js";
import "../__chunks/RS7KBRGA.js";
import {
  useStore,
  useStoreProps
} from "../__chunks/P63NRZ4A.js";
import "../__chunks/J7Q2EO23.js";
import "../__chunks/CP3U4HPL.js";
import {
  __spreadProps,
  __spreadValues
} from "../__chunks/PNRLI7OV.js";

// src/tab/tab-store.ts
import { useMemo } from "react";
import * as Core from "@ariakit/core/tab/tab-store";
function useTabStoreOptions(props) {
  return useCompositeStoreOptions(props);
}
function useTabStoreProps(store, props) {
  store = useCompositeStoreProps(store, props);
  useStoreProps(store, props, "selectedId", "setSelectedId");
  useStoreProps(store, props, "selectOnMove");
  const panels = useStore(() => store.panels);
  return useMemo(() => __spreadProps(__spreadValues({}, store), { panels }), []);
}
function useTabStore(props = {}) {
  const options = useTabStoreOptions(props);
  const store = useStore(() => Core.createTabStore(__spreadValues(__spreadValues({}, props), options)));
  return useTabStoreProps(store, props);
}
export {
  useTabStore,
  useTabStoreOptions,
  useTabStoreProps
};
